import CustomInput from '@app/components/CustomInput'
import { IReminder, Reminder } from '@app/models/Reminder'
import { bindFunctions } from '@app/utils/class'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { List } from 'immutable'
import * as React from 'react'
import {
  Button,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from 'reactstrap'

interface IRemindersEditorProps {
  className?: string
  onChange: (newValue: List<Reminder>) => void
  style?: React.CSSProperties
  value: List<IReminder>
}

export default class RemindersEditor extends React.PureComponent<
  IRemindersEditorProps,
  {}
> {
  constructor(props: IRemindersEditorProps) {
    super(props)
    bindFunctions(this)
  }

  public render() {
    return (
      <div>
        <a
          className='ml-2 text-primary'
          onClick={this._onAdd}
          style={{ cursor: 'pointer', fontSize: '0.875rem' }}
        >
          Add a reminder
        </a>
        {this._renderItems()}
      </div>
    )
  }

  public _renderItems() {
    if (this.props.value.size === 0) {
      return null
    }

    const item = this.props.value.toArray().map((reminder, index) => (
      <InputGroup key={index} className='mt-2'>
        <InputGroupAddon addonType='prepend'>
          <InputGroupText>
            <span className='font-weight-bold mr-2'>#{index + 1}</span>Remind me
          </InputGroupText>
        </InputGroupAddon>
        <CustomInput
          type='number'
          value={reminder.number}
          onChange={(e) => this._onChangeNumber(index, e)}
        />
        <Input
          type='select'
          value={reminder.period}
          onChange={(e) => this._onChangePeriod(index, e.target.value)}
        >
          <option value='Days'>Days</option>
          <option value='Weeks'>Weeks</option>
        </Input>
        <InputGroupAddon addonType='append'>
          <InputGroupText>before due date</InputGroupText>
          <Button
            color='danger'
            outline
            size='sm'
            onClick={() => this._onDelete(index)}
          >
            <FontAwesomeIcon icon={['fal', 'trash']} />
          </Button>
        </InputGroupAddon>
      </InputGroup>
    ))

    return item
  }

  private _onAdd() {
    const newReminders = this.props.value.push(new Reminder()) as List<
      Reminder
    >
    this.props.onChange(newReminders)
  }

  private _onChangeNumber(index: number, newNumber: number) {
    const newReminders = this.props.value.setIn(
      [index, 'number'],
      newNumber,
    ) as List<Reminder>
    this.props.onChange(newReminders)
  }

  private _onChangePeriod(index: number, newPeriod: string) {
    const newReminders = this.props.value.setIn(
      [index, 'period'],
      newPeriod,
    ) as List<Reminder>
    this.props.onChange(newReminders)
  }

  private _onDelete(index: number) {
    const newReminders = this.props.value.delete(index) as List<Reminder>
    this.props.onChange(newReminders)
  }
}
